import {Overlay} from "@angular/cdk/overlay";
import {Component, Input} from "@angular/core";
import {Subscription} from "rxjs";
import { ProductResultItemModel } from "../../../models/search/results/items/product-result-item.model";
import { DiscontinuedProductPopupService } from "../../../services/components/discontinued-product-popup.service";
import { QuickViewPopUpService } from "../../../services/components/quick-view-pop-up.service";
import { RegisterInterestPopUpService } from "../../../services/components/register-interest-pop-up.service";
import {Pending} from "../../../decorators/pending.decorator";
import {LockMixin} from "../../../mixins/lock.mixin";
import {EmptyMixin} from "../../../mixins/empty.mixin";
import {NotificationService} from "../../../services/components/notification.service";
import {ProductService} from "../../../services/product/product.service";
import {WishListService} from "../../../services/product/wish-list-service";
import {ProductResultItemPropertyModel} from "../../../models/search/results/items/product-result-item-property.model";

@Component({
    selector: "[pcg-ng-product-preview]",
    template: require('./product-preview.component.html')
})
export class ProductPreviewComponent extends LockMixin(EmptyMixin) {

    private ROW_OFFSET_ALIAS = "CatalogueNo";

    private URL_ALIAS_NAMES: Array<string> = [ "Name", "CatalogueNo" ];

    @Pending
    private getProductSubscription: Subscription;

    @Pending
    private addSubscription: Subscription;

    @Pending
    private removeSubscription: Subscription;

    @Input()
    public isColored: boolean;

    @Input()
    public product: ProductResultItemModel;

    @Input()
    public isGridView: boolean = true;

    @Input()
    public features: Array<ProductResultItemPropertyModel> = new Array<ProductResultItemPropertyModel>();

    public constructor(
        private overlay: Overlay,
        private wishListService: WishListService,
        private productService: ProductService,
        private quickViewPopUpService: QuickViewPopUpService,
        private notificationService: NotificationService,
        private registerInterestPopUpService: RegisterInterestPopUpService,
        private discontinuedProductPopupService: DiscontinuedProductPopupService
    ) {
        super();
    }

    public toggleWishListState(): void {
        if (!this.product.inWishList) {
            this.addToWishList();
        } else {
            this.removeFromWishList();
        }
    }

    private addToWishList(): void {
        this.addSubscription = this.wishListService.addToWishList(this.product.id)
            .subscribe(inWishList => this.product.inWishList = inWishList);
    }

    private removeFromWishList(): void {
        this.removeSubscription = this.wishListService.removeFromWishList(this.product.id)
            .subscribe(inWishList => this.product.inWishList = inWishList);
    }

    public getWishlistLabel(): string {
        if (this.product.inWishList) {
            return `Remove ${this.product.name} from Wishlist`;
        } else {
            return `Add ${this.product.name} to wishlist`;
        }
    }

    public handleQuickViewClick(): void {
        this.getProductSubscription = this.productService.getProductById(this.product.id)
            .subscribe(product => {
                if(product) {
                    if(product.accessioning) {
                        this.registerInterestPopUpService.showPopUp(product);
                    } else if(product.discontinued) {
                        this.discontinuedProductPopupService.showPopUp(product);
                    } else {
                        this.quickViewPopUpService.showPopUp(product);
                    }
                } else {
                    this.notificationService.showError("", "Requested product not found.");
                }
            });
    }
}
